var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkipForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6696 20.0564H20.2673C20.7686 20.0564 21.1464 19.9227 21.4008 19.6552C21.6553 19.3877 21.7826 18.9943 21.7826 18.4752V2.4034C21.7826 1.86846 21.6553 1.47316 21.4008 1.21749C21.1464 0.961819 20.7686 0.833984 20.2673 0.833984H17.6696C17.1759 0.833984 16.7999 0.967719 16.5417 1.23519C16.2834 1.50266 16.1543 1.89206 16.1543 2.4034V18.4752C16.1543 18.9943 16.2834 19.3877 16.5417 19.6552C16.7999 19.9227 17.1759 20.0564 17.6696 20.0564ZM2.14062 19.7024C2.37608 19.7024 2.59635 19.665 2.80144 19.5903C3.00651 19.5156 3.22298 19.4074 3.45085 19.2658L15.0606 12.1975C15.4631 11.9458 15.7555 11.6744 15.9378 11.3833C16.1201 11.0922 16.2113 10.7776 16.2113 10.4393C16.2113 10.101 16.1201 9.78635 15.9378 9.49528C15.7555 9.20421 15.4631 8.93281 15.0606 8.68107L3.45085 1.60099C3.21539 1.45939 2.99701 1.35122 2.79573 1.27649C2.59445 1.20176 2.37608 1.16439 2.14062 1.16439C1.69249 1.16439 1.30702 1.33746 0.984212 1.68359C0.661404 2.02973 0.5 2.5332 0.5 3.194V17.6846C0.5 18.3454 0.661404 18.8468 0.984212 19.1891C1.30702 19.5312 1.69249 19.7024 2.14062 19.7024Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipForward);
export default __webpack_public_path__ + "static/media/SkipForward.72545862bab1c525ba8f21a0cf98238a.svg";
export { ForwardRef as ReactComponent };